import Icon from '../components/Icon'

Icon.register({
  'hand-holding-medical': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M159.9 175.8c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h64v-64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64h-64zM568.1 336.1c4.9 6.6 7.8 14.8 7.8 23.7 0 13.2-6.4 24.9-16.3 32.2l-135 99.6c-17.3 12.7-38.7 20.2-61.7 20.3h-347c-8.8-0.1-15.9-7.2-16-16v-96c0.1-8.8 7.2-15.9 16-16h55.4l46.5-37.7c20.2-16.4 46.1-26.3 74.1-26.3h0 160c17.7 0 32.1 14.3 32.1 32 0 1.8-0.2 3.6-0.4 5.4-2.6 15.7-17.4 26.6-33.4 26.6h-78.2c-8.8 0-16 7.2-16 16 0 8.8 7.2 16 16 16h120.6l119.7-88.2c6.6-4.9 14.9-7.9 23.7-7.9 13.2 0 24.9 6.4 32.2 16.3z'
      }
    ]
  }
})
